/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type From_formValues = {
    readonly enabled: boolean;
    readonly fromName: string | null;
    readonly fromEmail: string | null;
    readonly " $refType": "From_formValues";
};
export type From_formValues$data = From_formValues;
export type From_formValues$key = {
    readonly " $data"?: From_formValues$data;
    readonly " $fragmentRefs": FragmentRefs<"From_formValues">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "From_formValues",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromName",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromEmail",
            "storageKey": null
        }
    ],
    "type": "EmailConfiguration",
    "abstractKey": null
} as any);
(node as any).hash = '217b6ffa441b69b63855358cf785cc86';
export default node;
